import React from 'react'
import { connect } from 'react-redux'
import { addListItem } from 'tyan/public/utility'
import { exportFile } from 'tyan/public/index'

class FlowRecordMailForm extends React.Component {
    state = {
        changedValues基本信息: {},
        flowRecordId: this.props.flowRecordId,
        id: this.props.id,
        emailTemplet: this.props.emailTemplet,
    }

    componentDidMount = () => {
        const { id } = this.props
        this.doGeFlowRecordMail(id)
    }
    componentWillUnmount = () => {
        this.unmount = true
    }
    doGeFlowRecordMail = (id) => {
        const { emailTemplet, flowRecordId } = this.state
        Tyan.doPostEvent({
            event: 'GeFlowRecordMail',
            data: { id, flowRecordId, emailTemplet },
            onEnd: ({ errorMessage, initValues基本信息, 附件, id }) => {
                if (errorMessage)
                    Tyan.pubForm.showError(errorMessage)
                else {
                    if (附件.FID) {
                        addListItem(this, { ...附件 }, '基本信息', '附件')
                    }
                    this.setState({ initValues基本信息, id })
                }
            }
        })
    }

    handleDeleteMail = () => {
        const { id } = this.state
        const { onRefresh, onClose } = this.props
        Tyan.pubForm.showConfirm('确定要删除？', () => Tyan.doPostEvent({
            event: 'DeleteFlowRecordMail',
            data: { id },
            onEnd: ({ errorMessage }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                    return
                }
                Ext.toast('删除成功')
                onRefresh && onRefresh()
                onClose && onClose()
            }
        }))
    }

    handleSendMail = () => {
        const { id, flowRecordId, changedValues基本信息, emailTemplet } = this.state
        const { onRefresh, onClose } = this.props
        Tyan.doPostEvent({
            event: 'SaveFlowRecordMail',
            data: { id, flowRecordId, changedValues基本信息, emailTemplet },
            onEnd: ({ errorMessage }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                    return
                }
                Ext.toast('保存成功')
                onRefresh && onRefresh()
                onClose && onClose()
            }
        })
    }

    handlerSupplierExport = () => {
        const { flowRecordId } = this.state
        exportFile(null, null, "SupplierExport?id=" + flowRecordId)
    }

    fieldset邮件信息 = () => {
        return [
            { _text: '主题', name: '主题', minWidth: '95%', required: true },
            { _text: '收件人', name: '收件人', minWidth: '95%', required: true },
            { _text: '抄送', name: '抄送', minWidth: '95%' },
            { _text: '邮件内容', minWidth: '95%', maxRows: 10, required: true },
            { _files: '附件' }
        ]
    }

    render() {
        const { showMessage: Message, onClose, showBody: Body } = this.props
        const { errorMessage, initValues基本信息, id } = this.state
        if (errorMessage) return Tyan.pubForm.showError(errorMessage)
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />
        return <Body data={this} minWidth="800" maxWidth="1100"
            controls={[
                { _button: '发送', icon: 'envelope-o', handler: () => this.handleSendMail(), cdt: () => initValues基本信息['状态'] != '已发送' },
                { _button: '删除', icon: 'trash-o', ui: 'action decline alt', handler: () => this.handleDeleteMail(), cdt: () => id > 0 && initValues基本信息['状态'] != '已发送' },
                { _button: '关闭', icon: 'close', handler: () => onClose && onClose() }
            ]}
            fieldsets={[{ title: '', name: '基本信息', _fieldset: this.fieldset邮件信息() }]}
        />
    }
}

export default connect()(FlowRecordMailForm)